<div id="body-wrapper">
  <main id="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
